export default {
    account: state => '我是账号'+state.user.account,
    validator:state=> state.validator,
    usercenter: state=> state.usercenter,
    lockStatus: state=> state.lockStatus,
    /*预约、挂号*/
    appointStatus: state=> state.appointModal,
    regStatus: state=> state.regModal,
    company: state=> state.company,

    teethInfoArr: state=> state.teethInfoArr,
    wSocket: state=> state.wSocket
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js